import {
  IButtonStyles,
  IconButton,
  Stack,
  Text,
  TooltipHost,
  useTheme,
} from '@fluentui/react';
import { StamperView } from 'common/components/StamperView';
import { StatusIcon } from 'common/components/StatusIcon';
import { useCommonStyles } from 'common/styles';
import { ApprovalHistory_Query } from '../__generated__/ApprovalHistory';
import { DocumentPackage } from '../DocumentPackage';

export interface ApprovalHistoryHeaderProps {
  approvalHistoryDetails: ApprovalHistory_Query | undefined;
  setShowBudgetChart: React.Dispatch<React.SetStateAction<boolean>>;
}
export const ApprovalHistoryHeader: React.FC<ApprovalHistoryHeaderProps> = ({
  approvalHistoryDetails,
  setShowBudgetChart,
}) => {
  const commonStyles = useCommonStyles();
  const theme = useTheme();

  const budgetIconStyle: IButtonStyles = {
    root: {
      color: approvalHistoryDetails?.approvalHistory?._budgetStatus
        ?._isOverBudget
        ? theme.palette.redDark
        : theme.palette.themePrimary,
    },
    iconHovered: {
      color: approvalHistoryDetails?.approvalHistory?._budgetStatus
        ?._isOverBudget
        ? theme.palette.redDark
        : theme.palette.themePrimary,
    },
  };
  return (
    <Stack
      grow
      horizontal
      verticalAlign="center"
      horizontalAlign="space-between"
    >
      <Stack verticalAlign="start">
        <Stack horizontal tokens={{ childrenGap: 10 }}>
          <Text variant="xLarge">Approval</Text>
          {approvalHistoryDetails?.approvalHistory?.approvalType
            ?.approvalType && (
            <Text variant="xLarge" className={commonStyles.colorThemePrimary}>
              {
                approvalHistoryDetails?.approvalHistory?.approvalType
                  ?.approvalType
              }
            </Text>
          )}
          {approvalHistoryDetails?.approvalHistory?.iconType && (
            <StatusIcon
              approval
              iconType={approvalHistoryDetails.approvalHistory.iconType}
            />
          )}

          <DocumentPackage
            documentPackageId={
              approvalHistoryDetails?.approvalHistory?._documentPackageId
            }
          />
        </Stack>
        <Stack>
          <Text className={commonStyles.colorThemeRed}>
            {
              approvalHistoryDetails?.approvalHistory
                ?.additionalApprovalInformation
            }
          </Text>
        </Stack>
      </Stack>
      {approvalHistoryDetails?.approvalHistory
        ?._accountingStampTransactionReference && (
        <StamperView
          invoiceDetails={{
            _accountingStampDate:
              approvalHistoryDetails?.approvalHistory?._accountingStampDate,
            _accountingStampTransactionReference:
              approvalHistoryDetails?.approvalHistory
                ?._accountingStampTransactionReference,
            _accountingStampUserName:
              approvalHistoryDetails?.approvalHistory?._accountingStampUserName,
            _isAccountingEntryStampedComplete:
              approvalHistoryDetails?.approvalHistory
                ?._isAccountingEntryStampedCompleted,
            _isTransactionCancelled:
              approvalHistoryDetails?.approvalHistory?._isTransactionCancelled,
          }}
        />
      )}
      {approvalHistoryDetails?.approvalHistory?._budgetStatus
        ?._isBudgetActive && (
        <TooltipHost
          content={
            approvalHistoryDetails?.approvalHistory?._budgetStatus
              ?._isOverBudget
              ? 'Over Budget'
              : 'Budget Status'
          }
        >
          <IconButton
            onClick={() => setShowBudgetChart(true)}
            iconProps={{
              iconName: 'BarChartVerticalFill',
              styles: {
                root: {
                  fontSize: '24px',
                },
              },
            }}
            styles={budgetIconStyle}
            ariaLabel="Chart"
          />
        </TooltipHost>
      )}
    </Stack>
  );
};
